import React from 'react';
import { includes } from 'lodash';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

const LayerFeatureSelector = ({ isFeature, layerSubType, setIsFeature }) => {
  if (includes([LAYER_SUBTYPES.GEOJSON, LAYER_SUBTYPES.REALTIME], layerSubType)) {
    return (
      <>
        <Form.Label>Layer from Feature Server</Form.Label>
        <Form.Group>
          <Form.Check
            name="Feature"
            label="Feature"
            defaultChecked={isFeature}
            onChange={() => {
              setIsFeature();
            }}
          />
        </Form.Group>
      </>
    );
  }
  return '';
};

LayerFeatureSelector.propTypes = {
  isFeature: PropTypes.bool.isRequired,
  layerSubType: PropTypes.string.isRequired,
  setIsFeature: PropTypes.func.isRequired
};

export default LayerFeatureSelector;
